const WATERSBUY_TOKEN_KEY = 'watersbuy_admin_token'

export const getToken = () => {
  return window.localStorage.getItem(WATERSBUY_TOKEN_KEY)
};

export const saveToken = token => {
  window.localStorage.setItem(WATERSBUY_TOKEN_KEY, token)
};

export const destroyToken = () => {
  window.localStorage.removeItem(WATERSBUY_TOKEN_KEY)
};

export const saveInfo = (KEY, VAL) => {
  window.localStorage.setItem(KEY, VAL)
};

export const getInfo = KEY => {
  return window.localStorage.getItem(KEY)
};


export default { getToken, saveToken, destroyToken, saveInfo, getInfo }


// WEBPACK FOOTER //
// ./src/common/jwt.service.js